var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.activeStep === 'levels')?_c('levels',{on:{"next":_vm.next}}):_vm._e(),(_vm.activeStep === 'teams')?_c('TeamsPreFormStep',{on:{"next":_vm.next}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }